var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusPurpose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2718 1.8334C18.3885 1.8334 20.1668 3.5934 20.1668 6.71924V15.2809C20.1668 18.3884 18.3977 20.1667 15.281 20.1667H6.71933C3.5935 20.1667 1.8335 18.3884 1.8335 15.2809V6.71924C1.8335 3.5934 3.5935 1.8334 6.71933 1.8334H15.2718ZM10.991 6.88424C10.5693 6.88424 10.2302 7.2234 10.2302 7.64507V10.2301H7.636C7.43433 10.2301 7.24183 10.3126 7.09516 10.4501C6.95766 10.5967 6.87516 10.7883 6.87516 10.9909C6.87516 11.4126 7.21433 11.7517 7.636 11.7609H10.2302V14.3551C10.2302 14.7767 10.5693 15.1159 10.991 15.1159C11.4127 15.1159 11.7518 14.7767 11.7518 14.3551V11.7609H14.3552C14.7768 11.7517 15.116 11.4126 15.116 10.9909C15.116 10.5692 14.7768 10.2301 14.3552 10.2301H11.7518V7.64507C11.7518 7.2234 11.4127 6.88424 10.991 6.88424Z",
    fill: "#605BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusPurpose);
export default __webpack_public_path__ + "static/media/plus-purpose.695ff060ce61dcd1e414c9976bff088c.svg";
export { ForwardRef as ReactComponent };